import { Form } from "../../components/abm/roles/Form";
import * as yup from 'yup';
import { Abm } from "./_Abm";
import { useAbmComponent } from "./useAbmComponent";
import { AbmWithContext } from "./_AbmWithContext";
import { useMemo } from "react";

const getSchemas = () => ({
  schemaAdd: yup.object().shape({
    nombre: yup.string().required().label("Nombre").default(""),
  }),
  schemaEdit: yup.object().shape({
    id: yup.number().required(),
    nombre: yup.string().required().label("Nombre").default(""),
  })
});
const entity = "roles";
const titleTable = "Roles";
const itemName = "Rol";
const itemDescription = item => `${itemName} ${item?.nombre || ''}`;
  const columns = [
    {field: "nombre", caption: "Nombre"},
    {field: "usuarios", caption: "Usuarios", render: (row) => row.usuarios.length, width: 80},
    {field: "_actions_", caption: "Acciones", width: 80}
  ];

export const Roles = ({abmKey}) => {
  const { schemaAdd, schemaEdit } = useMemo(() => getSchemas(), []);
  const abmComponent = useAbmComponent({abmKey, schemaAdd, schemaEdit, entity, titleTable, itemName, itemDescription, columns, FormComponent: Form})   
  return (
    <>
      <AbmWithContext abmComponent={abmComponent}      />
    </>
  );
}